import { Product, AddOnItem } from '../types';

export const ALL_PRODUCTS: Product[] = [
  {
    id: 'prod-1',
    name: 'Golden Halo Swirls',
    slug: 'golden-halo-swirls',
    price: 30.00,
    category: 'pastel-swirls',
    categoryLabel: 'Pastel Swirls',
    description: 'Directly inspired by the official Nailed It logo! Features dreamy lavender and baby pink marbled swirls, accented with delicate hand-drawn metallic gold foil ribbons and sparkling stars. Sealed with salon-grade high-gloss gel.',
    shortDescription: 'Pastel lavender & pink swirls with hand-drawn metallic gold chrome ribbons.',
    images: ['/nails/golden-halo-swirls.svg'],
    gradientStyle: 'from-[#FCE7F3] via-[#EDE9FE] to-[#FEF9C3]',
    accentColor: '#D4AF37',
    defaultShape: 'Almond',
    defaultLength: 'Medium',
    isBestSeller: true,
    rating: 5.0,
    reviewCount: 42,
    designDetails: [
      '100% Hand-painted with salon gel polish',
      'Dual-layer metallic gold chrome detailing',
      'Available in all shapes & custom measurements',
      'Reinforced apex for gymnastics-level durability'
    ]
  },
  {
    id: 'prod-2',
    name: 'Gymnast Gold Starburst',
    slug: 'gymnast-gold-starburst',
    price: 30.00,
    category: 'gymnast-chic',
    categoryLabel: 'Gymnast Collection',
    description: 'Designed by Kylee for athletic elegance! A milky pearl cream background layered with hand-applied 3D metallic gold star charms, micro-fairy glitter, and a chip-resistant protective builder gel coat.',
    shortDescription: 'Milky pearl base with 3D gold star charms and fairy dust shimmer.',
    images: ['/nails/gymnast-gold-starburst.svg'],
    gradientStyle: 'from-[#FEF9C3] via-[#FFFBEB] to-[#FDE68A]',
    accentColor: '#F59E0B',
    defaultShape: 'Coffin',
    defaultLength: 'Medium',
    isBestSeller: true,
    isNew: true,
    rating: 4.9,
    reviewCount: 38,
    designDetails: [
      'Encapsulated gold stars that will not snag or lift',
      'Soft pearlescent sheen under sunlight',
      'Includes full prep kit & strong adhesive tabs/glue',
      'Designed to withstand active routines'
    ]
  },
  {
    id: 'prod-3',
    name: 'Lilac Dream Waves',
    slug: 'lilac-dream-waves',
    price: 30.00,
    category: 'pastel-swirls',
    categoryLabel: 'Pastel Swirls',
    description: 'Vibrant lavender and royal lilac vortex waves layered over a soft cloud-white base. Accented with ultra-fine iridescent glitter swirls that catch the light with every hand movement.',
    shortDescription: 'Deep lilac and soft violet dimensional wave art with shimmer micro-particles.',
    images: ['/nails/lilac-dream-waves.svg'],
    gradientStyle: 'from-[#EDE9FE] via-[#DDD6FE] to-[#C4B5FD]',
    accentColor: '#8B5CF6',
    defaultShape: 'Almond',
    defaultLength: 'Medium',
    rating: 5.0,
    reviewCount: 29,
    designDetails: [
      'Multi-tonal purple gradient layering',
      'Hand-crafted swirl calligraphy lines',
      'Non-yellowing UV top coat',
      'Reusable up to 5+ times with proper care'
    ]
  },
  {
    id: 'prod-4',
    name: 'Royal Opal & Gold Stud',
    slug: 'royal-opal-and-gold-stud',
    price: 30.00,
    category: 'gold-sparkle',
    categoryLabel: 'Gold & Glam',
    description: 'Sophisticated minimalism at its finest. A crystalline champagne-shimmer base featuring a polished 18k-gold dome stud accent near the cuticle. Understated luxury that pairs with everything from competition leotards to evening wear.',
    shortDescription: 'Champagne crystal shimmer with centered 18k-gold dome stud embellishments.',
    images: ['/nails/royal-opal-stud.svg'],
    gradientStyle: 'from-[#FFFBEB] via-[#FEF3C7] to-[#FDE68A]',
    accentColor: '#D97706',
    defaultShape: 'Oval',
    defaultLength: 'Short',
    isBestSeller: false,
    rating: 4.8,
    reviewCount: 19,
    designDetails: [
      'Encapsulated metal studs (snag-free guarantee)',
      'Subtle holographic micro-sparkle background',
      'Ideal for shorter nail beds and active lifestyles',
      'Waterproof and sweat-resistant gel finish'
    ]
  },
  {
    id: 'prod-5',
    name: 'Pastel Sunset Ribbons',
    slug: 'pastel-sunset-ribbons',
    price: 30.00,
    category: 'pastel-swirls',
    categoryLabel: 'Pastel Swirls',
    description: 'An ethereal combination of baby pink, pastel seafoam mint, and soft lilac ribbons streaming diagonally across each nail, bounded by precision gold chrome contour lines.',
    shortDescription: 'Pastel pink, mint, and lilac ribbon flow with fine gold contour outlines.',
    images: ['/nails/pastel-sunset-ribbons.svg'],
    gradientStyle: 'from-[#CCFBF1] via-[#FCE7F3] to-[#EDE9FE]',
    accentColor: '#14B8A6',
    defaultShape: 'Almond',
    defaultLength: 'Medium',
    isBestSeller: true,
    rating: 5.0,
    reviewCount: 31,
    designDetails: [
      'Quad-color pastel harmonious palette',
      'Signature metallic gold barrier lines',
      'Hand-blended smooth transitions',
      '10-piece custom sized set + extra sizing tabs'
    ]
  },
  {
    id: 'prod-6',
    name: 'Buttercup & Rose Aura',
    slug: 'buttercup-and-rose-aura',
    price: 30.00,
    category: 'pastel-swirls',
    categoryLabel: 'Pastel Swirls',
    description: 'Playful and bright! Soft buttercup pastel yellow base meeting a candy pink wave, highlighted with a delicate molten gold framing wire aesthetic.',
    shortDescription: 'Warm pastel yellow & candy pink waves framed in molten gold chrome.',
    images: ['/nails/buttercup-rose-aura.svg'],
    gradientStyle: 'from-[#FEF08A] via-[#FDE68A] to-[#FCE7F3]',
    accentColor: '#EAB308',
    defaultShape: 'Square',
    defaultLength: 'Short',
    rating: 4.9,
    reviewCount: 16,
    designDetails: [
      'High-pigment Japanese gel formula',
      'Cute modern Y2K-inspired color blocking',
      'Comfort-fit curved C-curve',
      'Includes wood cuticle pusher & alcohol wipes'
    ]
  },
  {
    id: 'prod-7',
    name: 'Iridescent Mermaid Seafoam',
    slug: 'iridescent-mermaid-seafoam',
    price: 30.00,
    category: 'gymnast-chic',
    categoryLabel: 'Gymnast Collection',
    description: 'Shimmering pastel turquoise seafoam infused with mother-of-pearl chrome powder, topped with subtle gold glitter fade and clean white stars.',
    shortDescription: 'Mother-of-pearl seafoam chrome with gold shimmer gradient & stars.',
    images: ['/nails/iridescent-mermaid-seafoam.svg'],
    gradientStyle: 'from-[#E0F2FE] via-[#CCFBF1] to-[#99F6E4]',
    accentColor: '#0D9488',
    defaultShape: 'Almond',
    defaultLength: 'Medium',
    isNew: true,
    rating: 5.0,
    reviewCount: 24,
    designDetails: [
      'True mother-of-pearl mirror chrome finish',
      'Luminescent shifts under stage and natural lighting',
      'Triple-sealed edge prevention',
      'Ready to ship or custom sized in 2-3 business days'
    ]
  },
  {
    id: 'prod-8',
    name: 'Custom Bespoke Set (Made to Order)',
    slug: 'custom-bespoke-set',
    price: 30.00,
    category: 'custom',
    categoryLabel: 'Custom Commission',
    description: 'Work directly with Kylee to bring your dream nail concept to life! Send your inspiration photos, leotard colors, outfit moodboards, or favorite themes. Kylee will hand-paint a one-of-a-kind 10-piece luxury set just for you.',
    shortDescription: 'Have Kylee hand-paint your one-of-a-kind custom design or theme.',
    images: ['/nails/custom-design-by-kylee.svg'],
    gradientStyle: 'from-[#FDE68A] via-[#F472B6] to-[#A78BFA]',
    accentColor: '#D4AF37',
    defaultShape: 'Almond',
    defaultLength: 'Medium',
    isBestSeller: true,
    rating: 5.0,
    reviewCount: 57,
    designDetails: [
      '1-on-1 design consultation via notes/email',
      'Match any gymnastics team colors or event theme',
      'Custom sizing tailored down to the exact millimeter',
      'Photo preview sent before shipping'
    ]
  }
];

export const ADD_ON_ITEMS: AddOnItem[] = [
  {
    id: 'addon-prep-kit',
    name: 'Deluxe Application & Prep Kit',
    price: 5.00,
    description: 'Extra nail glue, 24 adhesive sticky tabs, dual-sided 100/180 grit file, 4 alcohol pads & mini cuticle oil pen.',
    icon: 'Sparkles'
  },
  {
    id: 'addon-sizing-kit',
    name: 'Physical Sizing Sample Kit',
    price: 6.00,
    description: '10 blank clear sample nails (sizes 0-9) sent in advance so you can guarantee an exact millimeter fit.',
    icon: 'Ruler'
  },
  {
    id: 'addon-strong-glue',
    name: 'Gymnast-Hold Extra Strength Glue',
    price: 4.00,
    description: 'Ultra-bond waterproof brush-on nail adhesive engineered to hold up through workouts and handstands.',
    icon: 'ShieldCheck'
  }
];

export const SIZING_PRESETS = [
  { name: 'XS', description: 'Extra Small', sizes: '3 · 6 · 5 · 7 · 9', mm: '14mm · 11mm · 12mm · 10mm · 8mm' },
  { name: 'S', description: 'Small (Most Popular)', sizes: '2 · 5 · 4 · 6 · 9', mm: '15mm · 12mm · 13mm · 11mm · 8mm' },
  { name: 'M', description: 'Medium', sizes: '1 · 5 · 4 · 6 · 8', mm: '16mm · 12mm · 13mm · 11mm · 9mm' },
  { name: 'L', description: 'Large', sizes: '0 · 4 · 3 · 5 · 7', mm: '18mm · 13mm · 14mm · 12mm · 10mm' },
  { name: 'Custom', description: 'Custom Sizing', sizes: 'Your exact mm measurements', mm: 'Measure with tape & ruler' },
];

export const SHAPE_OPTIONS: { id: string; name: string; desc: string; icon: string }[] = [
  { id: 'Almond', name: 'Almond', desc: 'Tapered, elegant & naturally elongating', icon: 'almond' },
  { id: 'Coffin', name: 'Coffin / Ballerina', desc: 'Modern tapered edges with crisp flat top', icon: 'coffin' },
  { id: 'Oval', name: 'Oval', desc: 'Classic rounded edge, very comfortable & durable', icon: 'oval' },
  { id: 'Square', name: 'Square', desc: 'Crisp parallel edges with straight tip', icon: 'square' },
  { id: 'Stiletto', name: 'Stiletto', desc: 'Dramatic sharp pointed tip for bold style', icon: 'stiletto' },
];

export const LENGTH_OPTIONS: { id: string; name: string; desc: string }[] = [
  { id: 'Short', name: 'Short', desc: 'Everyday wear & active lifestyle (12-16mm)' },
  { id: 'Medium', name: 'Medium', desc: 'Balanced length & flattering silhouette (18-22mm)' },
  { id: 'Long', name: 'Long', desc: 'Maximum glam & artistic canvas (24-28mm)' },
];

export const CUSTOMER_REVIEWS = [
  {
    id: 'rev-1',
    name: 'Sierra M.',
    location: 'Austin, TX',
    rating: 5,
    date: '2 days ago',
    verified: true,
    productName: 'Golden Halo Swirls',
    comment: 'Kylee is only 14 and honestly her hand-painted details rival salon sets I used to pay $120 for! The gold chrome swirls stayed flawless through a full week of cheer practice. Will definitely order again!',
    tags: ['Gymnast Approved', 'Reusable']
  },
  {
    id: 'rev-2',
    name: 'Brittany K.',
    location: 'Orlando, FL',
    rating: 5,
    date: '1 week ago',
    verified: true,
    productName: 'Gymnast Gold Starburst',
    comment: 'Bought these for my daughter’s gymnastics banquet. Everyone on her team asked where she got them! The sizing guide was 100% accurate and the packaging was so cute with the gold sparkles.',
    tags: ['Perfect Sizing', 'Great Gift']
  },
  {
    id: 'rev-3',
    name: 'Alexis T.',
    location: 'San Diego, CA',
    rating: 5,
    date: '2 weeks ago',
    verified: true,
    productName: 'Custom Bespoke Set',
    comment: 'I sent Kylee a photo of my competition leotard (teal and gold) and she made a custom set that matched it PERFECTLY! Super strong glue and gentle on my natural nails.',
    tags: ['Custom Design', 'Durable']
  },
  {
    id: 'rev-4',
    name: 'Hailey W.',
    location: 'Charlotte, NC',
    rating: 5,
    date: '3 weeks ago',
    verified: true,
    productName: 'Pastel Sunset Ribbons',
    comment: 'The quality of the gel polish is unbelievable. They have a nice sturdy curve and do not bend at all. Plus supporting a young female entrepreneur is awesome!',
    tags: ['High Quality Gel', 'Fast Shipping']
  }
];

export const FAQ_ITEMS = [
  {
    question: 'How long do Nailed It press-on nails stay on?',
    answer: 'With the included salon-strength liquid nail glue and proper nail bed preparation (buffing + alcohol wipe), your nails will stay firmly in place for 2 to 3+ weeks! If you prefer temporary weekend wear, use the included adhesive sticky tabs which last 2-4 days and allow instant damage-free removal.'
  },
  {
    question: 'Are Kylee’s hand-painted nails reusable?',
    answer: 'Yes, 100%! Because Kylee builds each nail with multiple layers of salon-grade builder gel and UV topcoat, they do not bend or crack. When applied with adhesive tabs or gently removed with warm soapy water and oil, you can reuse each set multiple times.'
  },
  {
    question: 'How do I find my nail size?',
    answer: 'Check out our interactive Sizing Guide on the website! All you need is a piece of scotch tape and a ruler measuring in millimeters. Measure the widest horizontal part of each nail bed, and match your numbers to our XS, S, M, or L presets. If you have unique sizes, simply select "Custom Sizing" and type in your 5 millimeter measurements at checkout for a bespoke fit at no extra charge.'
  },
  {
    question: 'What is included in every $30 order?',
    answer: 'Every order comes in a signature luxury storage box containing: 10 hand-painted gel press-on nails, 1 tube of strong nail glue, 1 sheet of 24 waterproof adhesive tabs, 1 dual-grit mini nail file & buffer, 1 wooden cuticle pusher stick, 2 alcohol prep wipes, and a step-by-step application card.'
  },
  {
    question: 'How does a custom commission order work?',
    answer: 'Simply select the "Custom Bespoke Set" or fill out the Custom Nail Request form. You can describe your favorite colors, gymnastics team colors, theme, or upload inspiration photos. Kylee will personally review your ideas and hand-paint your exclusive 1-of-a-kind set!'
  },
  {
    question: 'How long does shipping take?',
    answer: 'Since each set is handcrafted and hand-painted by Kylee, creation takes 2–4 business days. Standard US shipping takes 3–5 business days with tracking provided via email. Orders over $50 qualify for Free Shipping!'
  }
];
